import { EGYPT_CITIES } from './egyptCities';
import { OTHER_CITY_OPTION } from './types';

interface CityFieldProps {
  formId: string;
  governorate: string;
  cityChoice: string;
  customCity: string;
  error?: string;
  onSelectChange: (value: string) => void;
  onCustomChange: (value: string) => void;
  onBlur: () => void;
}

export default function CityField({
  formId,
  governorate,
  cityChoice,
  customCity,
  error,
  onSelectChange,
  onCustomChange,
  onBlur,
}: CityFieldProps) {
  const cities = governorate ? (EGYPT_CITIES[governorate] ?? []) : [];
  const isDisabled = !governorate;
  const isOther = cityChoice === OTHER_CITY_OPTION;
  const selectId = `${formId}-city`;
  const customInputId = `${formId}-city-custom`;
  const errorId = `${formId}-city-error`;

  return (
    <div className="space-y-3">
      <div>
        <label
          htmlFor={selectId}
          className="mb-2 block text-sm font-bold text-[#2C2C2C]"
        >
          المدينة / المركز
          <span className="ms-1 text-[#F46A6A]">*</span>
        </label>
        <select
          id={selectId}
          name="city"
          value={cityChoice}
          disabled={isDisabled}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
          onChange={(e) => onSelectChange(e.target.value)}
          onBlur={onBlur}
          className={`min-h-11 w-full rounded-xl border-2 bg-white px-4 py-3 text-base text-[#2C2C2C] transition-colors focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-[#707070] ${
            error
              ? 'border-[#F46A6A] focus:border-[#F46A6A] focus:ring-4 focus:ring-[#F46A6A]/10'
              : 'border-gray-200 focus:border-[#5B3FD0] focus:ring-4 focus:ring-[#5B3FD0]/10'
          }`}
        >
          <option value="">
            {isDisabled ? 'اختار المحافظة الأول' : 'اختار المدينة / المركز'}
          </option>
          {cities.map((cityName) => (
            <option key={cityName} value={cityName}>
              {cityName}
            </option>
          ))}
          {!isDisabled && (
            <option value={OTHER_CITY_OPTION}>أخرى (اكتبها)</option>
          )}
        </select>
      </div>

      {isOther && !isDisabled && (
        <div>
          <label
            htmlFor={customInputId}
            className="mb-2 block text-sm font-bold text-[#2C2C2C]"
          >
            اكتب اسم المدينة أو المركز
            <span className="ms-1 text-[#F46A6A]">*</span>
          </label>
          <input
            id={customInputId}
            name="customCity"
            type="text"
            value={customCity}
            maxLength={80}
            autoComplete="address-level2"
            placeholder="اكتب اسم المدينة أو المركز"
            aria-invalid={Boolean(error)}
            aria-describedby={error ? errorId : undefined}
            onChange={(e) => onCustomChange(e.target.value)}
            onBlur={onBlur}
            className={`min-h-11 w-full rounded-xl border-2 bg-white px-4 py-3 text-base text-[#2C2C2C] transition-colors placeholder:text-[#707070]/60 focus:outline-none ${
              error
                ? 'border-[#F46A6A] focus:border-[#F46A6A] focus:ring-4 focus:ring-[#F46A6A]/10'
                : 'border-gray-200 focus:border-[#5B3FD0] focus:ring-4 focus:ring-[#5B3FD0]/10'
            }`}
          />
        </div>
      )}

      {error && (
        <p
          id={errorId}
          role="alert"
          className="mt-1.5 text-sm font-semibold text-[#F46A6A]"
        >
          {error}
        </p>
      )}
    </div>
  );
}
